import { PageLayout } from '~/shared/ui/PageLayout/PageLayout';
import { Typography } from '~/shared/ui/Typography/Typography';

import { useLocalization } from '../localization/localization';

import { Root } from './NotFoundPage.ui';

export const NotFoundPage = () => {
  const { t } = useLocalization();

  return (
    <PageLayout>
      <Root>
        <Typography.H1>{t('title')}</Typography.H1>
      </Root>
    </PageLayout>
  );
};
